import React from "react";

type TrophyVariant = "bronzeFoundation" | "bronzeBuilder" | "silverProducer" | "maxLeadershipBonus";

type TrophyIconProps = {
  variant: TrophyVariant;
  size?: number;
};

export const TrophyIcon = ({ variant, size = 16 }: TrophyIconProps) => {
  const gradientId = `trophy-gradient-${variant}`;

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        {variant === "bronzeFoundation" && (
          <linearGradient
            id={gradientId}
            x1="0.32"
            y1="0.423645"
            x2="2.69401"
            y2="11.9842"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FDCBAC" />
            <stop offset="0.463542" stopColor="#DE8D59" />
            <stop offset="0.898838" stopColor="#F1B893" />
          </linearGradient>
        )}

        {variant === "silverProducer" && (
          <linearGradient id={gradientId} x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
            <stop stopColor="#BCBAC8" />
            <stop offset="1" stopColor="#3B3843" />
          </linearGradient>
        )}

        {variant === "maxLeadershipBonus" && (
          <linearGradient id={gradientId} x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
            <stop stopColor="#94A3CD" />
            <stop offset="1" stopColor="#1B3067" />
          </linearGradient>
        )}

        {variant === "bronzeBuilder" && (
          <linearGradient id={gradientId} x1="10.5" y1="2.5" x2="10.5" y2="18.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#B4641B" />
            <stop offset="1" stopColor="#66370B" />
          </linearGradient>
        )}
      </defs>

      {/* Background */}
      <circle cx="8" cy="8" r="8" fill={`url(#${gradientId})`} />

      {/* Trophy + STAR (exact original path) */}
      <path
        fill="white"
        d="M6.25 4.75C6.35938 7.26562 6.95312 8.375 7.375 8.84375C7.59375 9.07812 7.78125 9.1875 7.89062 9.21875C7.9375 9.23438 7.96875 9.25 7.98438 9.25C8.01562 9.25 8.04688 9.23438 8.09375 9.21875C8.20312 9.1875 8.39062 9.07812 8.60938 8.84375C9.03125 8.375 9.625 7.26562 9.71875 4.75H6.25ZM6.25 4H9.75C10.1562 4 10.5 4.34375 10.4844 4.76562C10.4688 4.84375 10.4688 4.92188 10.4688 5H12.125C12.3281 5 12.5 5.17188 12.5 5.375C12.5 7.07812 11.7812 8.15625 10.9062 8.82812C10.0625 9.48438 9.09375 9.73438 8.57812 9.82812C8.5 9.85938 8.4375 9.89062 8.375 9.92188V11.25H9.625C9.82812 11.25 10 11.4219 10 11.625C10 11.8438 9.82812 12 9.625 12H8H6.375C6.15625 12 6 11.8438 6 11.625C6 11.4219 6.15625 11.25 6.375 11.25H7.625V9.92188C7.5625 9.89062 7.48438 9.85938 7.40625 9.82812C6.89062 9.73438 5.92188 9.48438 5.07812 8.82812C4.20312 8.15625 3.5 7.07812 3.5 5.375C3.5 5.17188 3.65625 5 3.875 5H5.51562C5.51562 4.92188 5.51562 4.84375 5.5 4.76562C5.48438 4.34375 5.82812 4 6.25 4ZM9.59375 8.73438C9.875 8.60938 10.1719 8.45312 10.4531 8.23438C11.0781 7.75 11.6406 6.98438 11.7344 5.75H10.4062C10.2656 7.17188 9.95312 8.10938 9.59375 8.73438ZM5.53125 8.23438C5.8125 8.45312 6.10938 8.60938 6.39062 8.73438C6.03125 8.10938 5.71875 7.17188 5.57812 5.75H4.25C4.34375 6.98438 4.90625 7.75 5.53125 8.23438ZM8.10938 5.60938L8.32812 6.0625C8.34375 6.10938 8.39062 6.125 8.42188 6.14062L8.9375 6.20312C9.03125 6.21875 9.07812 6.34375 9 6.42188L8.64062 6.78125C8.60938 6.8125 8.59375 6.84375 8.59375 6.89062L8.6875 7.39062C8.70312 7.5 8.59375 7.57812 8.5 7.51562L8.04688 7.28125C8.01562 7.26562 7.96875 7.26562 7.9375 7.28125L7.48438 7.51562C7.39062 7.57812 7.28125 7.5 7.29688 7.39062L7.39062 6.89062C7.39062 6.84375 7.375 6.8125 7.34375 6.78125L6.98438 6.42188C6.90625 6.34375 6.95312 6.21875 7.04688 6.20312L7.5625 6.14062C7.59375 6.125 7.64062 6.10938 7.65625 6.0625L7.875 5.60938C7.92188 5.51562 8.0625 5.51562 8.10938 5.60938Z"
      />
    </svg>
  );
};
